import React, { useMemo } from 'react';
import AppSwitcherDiscoverySectionPlacement from '@post-office-placement/app-switcher-discovery-section/placement';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import AtlassianSwitcher, {
	fetchProductRecommendationsWithCollaborators,
	createJoinableSitesProvider,
} from '@atlassian/switcher';
import PostOfficePlacement from '@atlassian/post-office-placement/placement';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import { withFlags } from '@confluence/flags/entry-points/withFlags.ts';

import { customShowFlag } from './customShowFlag.tsx';

const maxHeightWrapper = xcss({
	maxHeight: 'calc(100vh - 100px)',
});

const joinableProductsInSwitcherProvider = createJoinableSitesProvider(
	fetchProductRecommendationsWithCollaborators('/gateway/api/invitations'),
);

export const AppSwitcherContent: React.ComponentType<Omit<unknown, 'flags'>> = withFlags(
	({ flags }: { flags: FlagsStateContainer }) => {
		const { cloudId } = useSessionData();
		const customShowFlagMemo = useMemo(() => customShowFlag(flags), [flags]);
		return (
			<Box xcss={maxHeightWrapper}>
				<AtlassianSwitcher
					product="confluence"
					cloudId={cloudId}
					joinableSitesDataProvider={joinableProductsInSwitcherProvider}
					showFlag={customShowFlagMemo}
					discoverySection={
						<PostOfficePlacement
							placementId="app-switcher-discovery-section"
							PlacementComponent={AppSwitcherDiscoverySectionPlacement}
						/>
					}
				/>
			</Box>
		);
	},
);
